import React, { useState, useEffect } from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import { Form, Col } from 'react-bootstrap'
import config from '../../config/config'

const PoiStatusSelect = ({ selectedPoiStatus, isEvent, onChange }) => {
  const [statusOptions, setStatusOptions] = useState([])

  useEffect(() => {
    const fetchStatusOptions = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}poi-status`, {
          params: {
            'is-event': isEvent,
          },
        })
        setStatusOptions(response.data)
      } catch (error) {
        //console.error('An error occurred while fetching status options:', error);
      }
    }

    fetchStatusOptions()
  }, [isEvent])

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value
    if (onChange) {
      onChange(selectedValue)
    }
  }

  useEffect(() => {
    if (!selectedPoiStatus && statusOptions.length > 0) {
      onChange(statusOptions[0].name)
    }
  }, [statusOptions, onChange, selectedPoiStatus])

  return (
    <Form.Group as={Col} controlId="statusSelect">
      <Form.Label>Statut</Form.Label>
      <Form.Control
        as="select"
        value={selectedPoiStatus}
        onChange={handleSelectChange}
      >
        {statusOptions.map((option) => (
          <option key={option.name} value={option.name}>
            {option.labelFr}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  )
}

PoiStatusSelect.propTypes = {
  selectedPoiStatus: PropTypes.string.isRequired,
  isEvent: PropTypes.bool,
  onChange: PropTypes.func,
}

export default PoiStatusSelect
